import { render, staticRenderFns } from "./CsvImport.vue?vue&type=template&id=55c8638d&scoped=true&"
import script from "./CsvImport.vue?vue&type=script&lang=js&"
export * from "./CsvImport.vue?vue&type=script&lang=js&"
import style0 from "./CsvImport.vue?vue&type=style&index=0&id=55c8638d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c8638d",
  null
  
)

export default component.exports